"use client";

const COLOR_CODE_MAP: Record<string, string> = {
  red: "R",
  blue: "U",
  green: "G",
  yellow: "Y",
  purple: "P",
  black: "B",
};

const COLOR_BG_MAP: Record<string, string> = {
  R: "bg-red-700/70 text-red-100",
  U: "bg-blue-700/70 text-blue-100",
  G: "bg-green-700/70 text-green-100",
  Y: "bg-yellow-600/70 text-yellow-100",
  P: "bg-purple-700/70 text-purple-100",
  B: "bg-slate-700/70 text-slate-100",
};

export function colorShortCode(color: string): string {
  return COLOR_CODE_MAP[color.toLowerCase()] ?? color.charAt(0).toUpperCase();
}

export function ColorBadges({ colors }: { colors?: string[] }) {
  if (!colors?.length) return null;
  return (
    <div className="flex gap-0.5">
      {colors.map((c) => {
        const code = colorShortCode(c);
        const classes = COLOR_BG_MAP[code] ?? "bg-slate-600/70 text-slate-200";
        return (
          <span
            key={c}
            className={`inline-flex h-4 w-4 items-center justify-center rounded text-micro font-bold leading-none ${classes}`}
            title={c}
          >
            {code}
          </span>
        );
      })}
    </div>
  );
}

/** Same footprint as a color chip: block-icon requirement (shield number on the physical card). */
export function BlockIconBadge({
  blockIcon,
}: {
  blockIcon: string | null | undefined;
}) {
  if (blockIcon == null) return null;
  const v = String(blockIcon).trim();
  if (!v) return null;
  return (
    <span
      className="inline-flex h-4 min-w-4 shrink-0 items-center justify-center rounded px-0.5 text-micro font-mono font-bold leading-none bg-amber-900/80 text-white"
      title={`Block icon ${v}`}
    >
      {v}
    </span>
  );
}
